module.exports = __webpack_public_path__ + "img/repair_jia.7030b805.png";